import { createContext } from 'react';
import { tictactoeState, setTictactoe } from './common'
import { memoVisibleState, setMemoVisibleState } from './memoVisible'

export const initialState = {
    ...tictactoeState,
    ...memoVisibleState
}

export const reducer = (state: any, action: any): any => {
    let store = state
    store = setTictactoe(state, action)
    store = setMemoVisibleState(store, action)
    return store
}
 
const StoreContext: any = createContext(initialState);
 
export default StoreContext;